// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b0K4","toggle":"styles_toggle__34udr","preview":"styles_preview__yRHhn"};